<template>
  <img
    v-if="user && user.photo"
    :src="user.photo.fullPath"
    alt="avatar"
    class="avatar"
  />
  <div v-else class="avatar placeholder">{{ initials }}</div>
</template>

<script>
export default {
  name: 'Avatar',
  props: { user: Object },
  computed: {
    initials() {
      const name = (this.user && this.user.name) ? this.user.name[0] : ''
      const surname = (this.user && this.user.surname) ? this.user.surname[0] : ''
      const combined = name + surname
      return combined ? combined : '?'
    },
  },
}
</script>

<style scoped>
.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 0.75rem;
}
.avatar.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
  color: #555;
  font-weight: 600;
}
</style>
